<template>
  <div class="hm-rating-info-container">
    <div class="title">{{ $t('hm.resume.hiringManagerRating') }}</div>
    <div class="body-container">
      <div class="rating-container">
        <div class="total-score">
          <span class="description">Overall</span>
          <span class="score">{{ total_avg_score }}</span>
        </div>
        <div
          class="rating-item-container"
          v-for="(item, index) in ratingList"
          :key="index"
          >
          <div class="left">
            <span class="hm-name">{{ item.hm_name }}:</span>
            <span class="rating-time">{{ item.submit_time }}</span>
          </div>
          <div class="middle">
            <van-rate class="rating-rate" v-model="item.total_rate" size="28" color="#808080" :readonly="true" :count="6"/>
            <div class="comment-container">
              <span class="title">{{ $t('hm.label.commentLabel') }}</span>
              <span class="value">{{ item.comment }}</span>
            </div>
          </div>
          <div class="right">
            <div class="rating-status status-outer" :class="getRatingColorByStatus(item.status)">
              <div class="status-inner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  components: {
  },
  props: {
    hmRatingInfo: {
      require: true
    }
  },
  data () {
    return {
      ratingList: [],
      total_avg_score: 0
    }
  },
  computed: {
  },
  created () {
    this.ratingList = this.hmRatingInfo.rate_list
    this.total_avg_score = this.hmRatingInfo.total_avg_rate
    this.ratingList.forEach(item => {
      item.total_rate = _.parseInt(item.total_rate)
    })
  },
  beforeDestroy () {

  },
  methods: {
    getRatingColorByStatus (status) {
      if (status === 2 || status === '2') {
        return 'green'
      } else if (status === 0 || status === '0') {
        return 'red'
      } else if (status === 1 || status === '1') {
        return 'yellow'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hm-rating-info-container {
  margin: 20px 0;

  > .title {
    font-size: 20px;
    padding: 10px 0 5px 10px;
    border-bottom: 1px solid #b4b4b4;
    margin-bottom: 20px;
    font-weight: 600;
  }

  .body-container {
    background: #FFFFFF;
    padding: 40px 60px;
  }

  .rating-container {
    position: relative;
    border-radius: 15px;
    padding: 10px 30px;
    border: 1px solid #b4b4b4;

    .total-score {
      position: absolute;
      background-color: #FFFFFF;
      width: 80px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      right: -40px;
      top: -30px;
      border: 3px solid #c9c9c9;
      border-radius: 50%;
      color: #606266;

      .description {
        padding-top: 5px;
      }

      .score {
        font-size: 35px;
        font-weight: 700;
        color: #909399;
      }
    }

    .rating-item-container {
      padding: 20px 20px 0 20px;
      display: flex;
      font-size: 12px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      > .left {
        width: 30%;
        text-align: right;
        display: flex;
        flex-direction: column;
        color: #606266;

        .hm-name {
          font-size: 16px;
          margin-bottom: 5px;
        }
      }

      > .middle {
        width: 40%;
        padding: 0 30px;

        .comment-container {
          margin-top: 20px;
          font-size: 16px;
          color: #606266;

          .value {
            margin-left: 10px;
            white-space: pre-wrap;
          }
        }
      }

      > .right {
        width: 30%;
        display: flex;
        justify-content: center;

        .rating-status {
          border: 1px solid #808080;
          padding: 4px;
          height: 24px;
          width: 24px;
          border-radius: 50%;

          .status-inner {
            background-color: #808080;
            height: 24px;
            width: 24px;
            border-radius: 50%;
          }

          &.green {
            border-color: #008000;

            .status-inner {
              background-color: #008000;
            }
          }

          &.red {
            border-color: #ff0000;

            .status-inner {
              background-color: #ff0000;
            }
          }

          &.yellow {
            border-color: #ffff00;

            .status-inner {
              background-color: #ffff00;
            }
          }
        }
      }

    }
  }

  ::v-deep .rating-rate {

    .van-rate__item:not(:last-child) {
      padding-right: 20px;
    }
  }
}
</style>
